<!-- 新版 替补阵容  -->
<template>
  <div
    class="lineup_subList"
    :class="themeClass"
    v-if="subPlayerList && subPlayerList.length > 0"
  >
    <!-- <div class="subLineup_title" v-text="'替补阵容'"></div> -->
    <div
      class="table_container"
      :style="{
        height: `calc(${viewBoxHeight})`,
      }"
    >
      <ul
        class="tableUl"
        v-for="(teamList, teamInd) in formatSubLineups"
        :key="teamInd"
        :class="[
          homeAwayArr ? homeAwayArr[teamInd] : '',
          realityRowNum && teamList && realityRowNum === teamList.length
            ? 'maxTeam'
            : '',
        ]"
      >
        <li
          class="itemRow"
          v-for="(player, index) in teamList"
          :key="player.playerId"
          :style="{
            opacity: `${index > shrinkRowNum - 1 && !shrinkTypeFlag ? 0 : 1}`,
          }"
        >
          <span class="leftPlayerItem" @click="playerDetail(player, 'sub')">
            <span class="playerLogo">
              <img v-show="player.playerLogo" :src="player.playerLogo" />
              <span v-show="!player.playerLogo" class="defautlPlayerImg"></span>
              <span
                class="shirtNumber"
                v-text="_valFormatHandler(player.shirtNumber)"
              ></span>
            </span>
            <span class="inforRow">
              <span class="inforRow_1">
                <span
                  class="playerName"
                  v-text="_valFormatHandler(player.playerName)"
                ></span>
                <span
                  class="playerPos"
                  v-text="_valFormatHandler(player.positionName)"
                ></span>
                <span
                  v-if="![null, undefined].includes(player.score)"
                  class="playerGrade"
                  v-text="_valFormatHandler(player.score)"
                ></span>
              </span>
              <span
                class="inforRow_2"
                v-if="player.playerEvents && player.playerEvents.length > 0"
              >
                <template v-for="(event, eventIndex) in player.playerEvents">
                  <span
                    v-if="event.eventCodeWeb - 0 == 7"
                    :key="eventIndex"
                    v-text="'受伤'"
                    :class="
                      eventTypeClass[event.eventCodeWeb]
                        ? eventTypeClass[event.eventCodeWeb]
                        : ''
                    "
                  ></span>
                  <span
                    v-if="
                      event.eventCodeWeb - 0 >= 0 && event.eventCodeWeb - 0 <= 6
                    "
                    :key="eventIndex"
                    v-text="
                      event.eventCodeWeb == 3 || event.eventCodeWeb == 6
                        ? _valFormatHandler(event.time)
                        : ''
                    "
                    :class="
                      eventTypeClass[event.eventCodeWeb]
                        ? eventTypeClass[event.eventCodeWeb]
                        : ''
                    "
                  ></span>
                </template>
                <!-- <span class="goal"></span>
                  <span class="yellowCard"></span>
                  <span class="redCard"></span>
                  <span class="offStage" v-text="'45'"></span> -->
              </span>
            </span>
          </span>
          <span
            class="rightPlayerItem"
            v-if="player.startPlayer && player.startPlayer.playerName"
          >
            <span class="inforRow">
              <span class="inforRow_1">
                <span
                  class="playerName"
                  v-text="_valFormatHandler(player.startPlayer.playerName)"
                ></span>
                <span
                  class="playerGrade"
                  v-text="_valFormatHandler(player.startPlayer.playerGrade)"
                ></span>
              </span>
              <span
                class="inforRow_2"
                v-show="
                  player.startPlayer.playerEvents &&
                  player.startPlayer.playerEvents.length > 0
                "
              >
                <template
                  v-for="(event, eventIndex) in player.startPlayer.playerEvents"
                >
                  <span
                    :key="eventIndex"
                    v-text="
                      event.eventCodeWeb == 3 || event.eventCodeWeb == 6
                        ? _valFormatHandler(event.time)
                        : ''
                    "
                    v-if="
                      event.eventCodeWeb - 0 >= 0 && event.eventCodeWeb - 0 <= 6
                    "
                    :class="eventTypeClass[event.eventCodeWeb]"
                  ></span>
                </template>
              </span>
            </span>
          </span>
        </li>
      </ul>
      <div
        class="shrinkBox borderRadius"
        v-if="isShrinkFlag"
        @click="shrinkTypeHandler"
      >
        <span class="shrinkText" v-text="shrinkText"></span>
        <span
          class="arrowIcon unquoteClass"
          :class="shrinkTypeFlag ? '' : 'show'"
        ></span>
      </div>
    </div>
  </div>
</template>
<script>
// 替补名单
export default {
  name: 'lineup_subList',
  props: {
    datas: {
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
      // 测试数据，主要是事件id
      // default: () => ({
      //   objectInfo: [],
      //   data: {
      //     dataList: [
      //     //替补名单
      //     [
      //       {
      //         shirtNumber: 1,
      //         playerName: '佛朗哥·阿尔马尼',
      //         playerId: 100710,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100710.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //         positionName: '中场',
      //         score: '9.0', //评分
      //         playerEvents: [
      //           {
      //             type: 6, //上场
      //             time: '35’',
      //           },
      //           {
      //             type: 0, //点球
      //             time: '50’',
      //           },
      //           {
      //             type: 1, //乌龙球
      //             time: '51’',
      //           },
      //           {
      //             type: 2, //进球
      //             time: '55’',
      //           },
      //           // {
      //           //   type: 4, //黄牌
      //           //   time: "60’",
      //           // },
      //           {
      //             type: 5, //红牌
      //             time: '65’',
      //           },
      //           {
      //             type: 3, //下场
      //             time: '85’',
      //           },
      //           {
      //             type: 7, //受伤
      //             time: '85’',
      //           },
      //         ],
      //         startPlayer: {
      //           playerName: '林德勒夫',
      //           score: '8.7',
      //           playerEvents: [
      //             {
      //               type: 3, //下场
      //               time: '35’',
      //             },
      //           ],
      //         },
      //       },
      //       {
      //         shirtNumber: 2,
      //         playerName: '胡安·福伊特',
      //         playerId: 100679,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100679.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //         positionName: '前锋',
      //         score: '9.0', //评分
      //         playerEvents: [
      //           {
      //             type: 6, //上场
      //             time: '35’',
      //           },
      //           {
      //             type: 0, //点球
      //             time: '50’',
      //           },
      //           {
      //             type: 1, //乌龙球
      //             time: '51’',
      //           },
      //           {
      //             type: 2, //进球
      //             time: '55’',
      //           },
      //           {
      //             type: 4, //黄牌
      //             time: '60’',
      //           },
      //           {
      //             type: 5, //红牌
      //             time: '65’',
      //           },
      //           {
      //             type: 3, //下场
      //             time: '85’',
      //           },
      //         ],
      //         startPlayer: {
      //           playerName: '林德勒夫',
      //           score: '8.7',
      //           playerEvents: [
      //             {
      //               type: 3, //下场
      //               time: '35’',
      //             },
      //           ],
      //         },
      //       },
      //       {
      //         shirtNumber: 4,
      //         playerName: '贡萨洛·蒙铁尔',
      //         playerId: 102628,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102628.png',
      //         points: 2.5,
      //         type: 'on',
      //         time: '90′0″',
      //         time2: '90′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 5,
      //         playerName: '莱安德罗·帕雷德斯',
      //         playerId: 100698,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100698.png',
      //         points: 6.4,
      //         type: 'on',
      //         time: '101′52″',
      //         time2: '101′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 6,
      //         playerName: '赫尔曼·佩泽拉',
      //         playerId: 100692,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100692.png',
      //         points: 6,
      //         type: 'on',
      //         time: '115′21″',
      //         time2: '115′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 8,
      //         playerName: '马科斯·阿库尼亚',
      //         playerId: 100716,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100716.png',
      //         points: 4.9,
      //         type: 'on',
      //         time: '63′51″',
      //         time2: '63′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 12,
      //         playerName: '赫罗尼莫·鲁利',
      //         playerId: 100668,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100668.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 14,
      //         playerName: '埃塞基耶尔·帕拉西奥斯',
      //         playerId: 100684,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100684.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 15,
      //         playerName: '安赫尔·科雷亚',
      //         playerId: 100683,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100683.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 16,
      //         playerName: '蒂亚戈·阿尔马达',
      //         playerId: 102631,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102631.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 17,
      //         playerName: '亚历杭德罗·戈麦斯',
      //         playerId: 100695,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100695.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 18,
      //         playerName: '吉多·罗德里格斯',
      //         playerId: 100686,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100686.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 21,
      //         playerName: '保罗·迪巴拉',
      //         playerId: 100696,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100696.png',
      //         points: 6,
      //         type: 'on',
      //         time: '120′44″',
      //         time2: '120′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 22,
      //         playerName: '劳塔罗·马丁内斯',
      //         playerId: 100691,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100691.png',
      //         points: 4,
      //         type: 'on',
      //         time: '102′9″',
      //         time2: '102′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 25,
      //         playerName: '利桑德罗·马丁内斯',
      //         playerId: 102634,
      //         teamId: 1020,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102634.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //     ],

      //     [
      //       {
      //         shirtNumber: 2,
      //         playerName: '邦雅曼·帕瓦尔',
      //         playerId: 100110,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100110.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //         positionName: '中场',
      //         score: '9.0', //评分
      //         playerEvents: [
      //           {
      //             type: 6, //上场
      //             time: '35’',
      //           },
      //           {
      //             type: 0, //点球
      //             time: '50’',
      //           },
      //           {
      //             type: 1, //乌龙球
      //             time: '51’',
      //           },
      //           {
      //             type: 2, //进球
      //             time: '55’',
      //           },
      //           // {
      //           //   type: 4, //黄牌
      //           //   time: "60’",
      //           // },
      //           {
      //             type: 5, //红牌
      //             time: '65’',
      //           },
      //           {
      //             type: 3, //下场
      //             time: '85’',
      //           },
      //           {
      //             type: 7, //受伤
      //             time: '85’',
      //           },
      //         ],
      //         startPlayer: {
      //           playerName: '林德勒夫',
      //           score: '8.7',
      //           playerEvents: [
      //             {
      //               type: 3, //下场
      //               time: '35’',
      //             },
      //           ],
      //         },
      //       },
      //       {
      //         shirtNumber: 3,
      //         playerName: '阿克塞尔·迪萨西',
      //         playerId: 116256,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/116256.png',
      //         points: null,
      //         type: 'on',
      //         time: '120′13″',
      //         time2: '120′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 6,
      //         playerName: '马泰奥·冈杜齐',
      //         playerId: 102795,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102795.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 12,
      //         playerName: '兰德尔·科洛',
      //         playerId: 102800,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102800.png',
      //         points: 3.4,
      //         type: 'on',
      //         time: '40′31″',
      //         time2: '40′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 13,
      //         playerName: '优素福·福法纳',
      //         playerId: 102796,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102796.png',
      //         points: 6.1,
      //         type: 'on',
      //         time: '95′9″',
      //         time2: '95′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 15,
      //         playerName: '若尔丹·韦勒图',
      //         playerId: 102789,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102789.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 16,
      //         playerName: '史蒂夫·曼丹达',
      //         playerId: 100102,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100102.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 17,
      //         playerName: '威廉·萨利巴',
      //         playerId: 102791,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102791.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 20,
      //         playerName: '金斯利·科芒',
      //         playerId: 100085,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100085.png',
      //         points: 5.5,
      //         type: 'on',
      //         time: '70′26″',
      //         time2: '70′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 23,
      //         playerName: '阿方斯·阿雷奥拉',
      //         playerId: 101073,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/101073.png',
      //         points: null,
      //         type: '',
      //         time: null,
      //         time2: null,
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 24,
      //         playerName: '易卜拉希马·科纳特',
      //         playerId: 102306,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102306.png',
      //         points: 6.3,
      //         type: 'on',
      //         time: '112′15″',
      //         time2: '112′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 25,
      //         playerName: '爱德华多·卡马温加',
      //         playerId: 102798,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102798.png',
      //         points: 6.9,
      //         type: 'on',
      //         time: '70′38″',
      //         time2: '70′',
      //         teamLogo: '',
      //       },
      //       {
      //         shirtNumber: 26,
      //         playerName: '马库斯·图拉姆',
      //         playerId: 100092,
      //         teamId: 1008,
      //         playerLogo:
      //           'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100092.png',
      //         points: 5.5,
      //         type: 'on',
      //         time: '40′58″',
      //         time2: '40′',
      //         teamLogo: '',
      //       },
      //     ],
      //   ]
      //   },
      //   statisticsModels: [],
      // }),
    },
    themeClass: {
      type: String,
      default: '',
    },
    detailPathName: {
      type: String,
      default: '',
    },
    shrinkRowNum: {
      //大于等于6时展示【展示|收起】按钮
      type: Number,
      default: 6,
    },
    defaultTeamImg: {
      type: String,
      default:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAlqADAAQAAAABAAAAlgAAAAAXS0ggAAAC5klEQVR4Ae3SsQ3CQBREQYPoG3pADqnVNOCNXjoX3tcmo3ccHgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIEg8Piev3fYmxK4FXhd1/W5vfgkEASeYWtKYAoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT1bAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACB4w8i3waNTi4J/gAAAABJRU5ErkJggg==',
    },
    homeAwayArr: {
      type: Array,
      default: () => {
        return ['home', 'away']
      },
    },
  },
  data() {
    return {
      // homeAwayArr: ['home', 'away'],
      eventTypeClass: [
        'point',
        'ownGoal',
        'goal',
        'offStage',
        'yellowCard',
        'redCard',
        'onStage',
        'injured',
      ],
      showRowNum: 0,
      realityRowNum: 0, //数据实际行数
      isShrinkFlag: false, //是否显示 展示||收起 dom, true:显示 ，false：不显示
      shrinkTypeFlag: false, //false: 未展开， true： 展开；
      shrinkText: '展开',
      subPlayerList: [],
      // shrinkRowNum: 6, //大于等于6时展示【展示|收起】按钮
      // defaultTeamImg:
      //   'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAlqADAAQAAAABAAAAlgAAAAAXS0ggAAAC5klEQVR4Ae3SsQ3CQBREQYPoG3pADqnVNOCNXjoX3tcmo3ccHgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIEg8Piev3fYmxK4FXhd1/W5vfgkEASeYWtKYAoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT1bAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACB4w8i3waNTi4J/gAAAABJRU5ErkJggg==',
    }
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        let formatSubLineups = []
        newVal.data.dataList.forEach((teams) => {
          const formatTeams = []
          teams.forEach((player) => {
            if (player.playerEvents) {
              player.playerEvents.forEach((event) => {
                event.eventCodeWeb = this.eventCode2eventCodeWeb(event.type)
              })
            }
            if (player.startPlayer) {
              player.startPlayer.playerEvents.forEach((event) => {
                event.eventCodeWeb = this.eventCode2eventCodeWeb(event.type)
              })
            }
            // if (player.playerId && player.playerName) {
            //   // 过滤没有playerId、playerName的球员，这球员有问题，因此替补阵容不展示有问题的球员，其他正常展示
            //   formatTeams.push(player);
            // }

            if (player.playerId) {
              // 过滤没有playerId、playerName的球员，这球员有问题，因此替补阵容不展示有问题的球员，其他正常展示
              formatTeams.push(player)
            }
          })
          formatSubLineups.push(formatTeams)
        })

        this.formatSubLineups = formatSubLineups
        let maxTeamNum = 0
        formatSubLineups.forEach((singleTeam, index) => {
          if (singleTeam && singleTeam.length > maxTeamNum) {
            maxTeamNum = singleTeam.length
          }
        })
        this.realityRowNum = maxTeamNum
        this.isShrinkFlag = this.realityRowNum > this.shrinkRowNum
        this.showRowNum =
          this.isShrinkFlag && !this.shrinkTypeFlag
            ? this.shrinkRowNum
            : this.realityRowNum

        console.debug('newVal', formatSubLineups)
        this.subPlayerList = formatSubLineups
        formatSubLineups = null
      },
      immediate: true,
      // deep: true,
    },
    shrinkRowNum: {
      handler(newVal, oldVal) {
        if (this.shrinkTypeFlag) {
          // 只有展开后才需要判断是不是因此按钮一行的高度， 即此时 shrinkText = '收起'
          if (newVal === 1000) {
            // 等于1000，则默认是不需要【展示】按钮
            this.shrinkText = ''
          } else {
            this.shrinkText = '收起'
          }
        } else {
          if (newVal === 1000) {
            // 等于1000，则默认是不需要【展示】按钮
            this.shrinkText = ''
          } else {
            this.shrinkText = '展开'
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    viewBoxHeight() {
      //   console.debug(112312, this.showRowNum);
      // var shrinkBox = this.isShrinkFlag ? 70 : 20;
      // var heightRem = (shrinkBox + 40 + 90 * this.showRowNum)/100;
      // heightRem = shrinkBox + 5.333 + 13 * this.showRowNum;
      // const clientWidth = window.innerWidth || window.screen.width
      const shrinkBox = 0
      let heightRem = 0
      //   if (clientWidth == 320) {
      //     heightRem = 14.0625 * this.showRowNum
      //   } else {
      //     heightRem = 12 * this.showRowNum
      //   }
      if (this.shrinkText === '收起') {
        heightRem = 4.16 * this.showRowNum + 4.16 //如果存在收起按钮时，展示时需要把【收起】按钮的高度留出来
      } else {
        heightRem = 4.16 * this.showRowNum
      }

      return `${shrinkBox}rem + ${heightRem}vw`
    },
  },
  methods: {
    openFloatLayer(item, state) {
      // console.debug(
      //   "scrollTop:",
      //   window.document.getElementsByClassName("comp-item")[0].scrollTop
      // );
      if (
        state == 'sub' &&
        (!item.startPlayer || !item.startPlayer.playerName)
      ) {
        return
      }

      const scrollTop = document.scrollingElement.scrollTop
      document.body.classList.add('modalOpen')
      document.body.style.top = `-${scrollTop}px`
      console.debug(scrollTop)
      //   this.set_parentScrollTopPx(scrollTop)
      //   this.set_floatLayerCurPlayer(item)
      //   this.set_isFloatLayer(true)
    },
    playerDetail(item) {
      // console.debug(item)
      if (this.detailPathName) {
        const query = this.$route.query
        let params = {
          cid: query && query.cid ? query.cid : '',
          sid: query && query.sid ? query.sid : '',
          tid: item.teamId,
          pid: item.playerId,
        }
        // console.debug(params)
        this.openNewWeb(this.$router, this.detailPathName, params)
      }
    },
    _valFormatHandler(val) {
      var data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '-'
      } else {
        data = val
      }
      // console.debug(val, data)
      return data
    },
    shrinkTypeHandler() {
      console.debug(this.showRowNum, this.realityRowNum, this.shrinkRowNum)
      this.shrinkTypeFlag = !this.shrinkTypeFlag
      if (this.shrinkTypeFlag) {
        this.showRowNum = this.realityRowNum
        this.shrinkText = '收起'
      } else {
        this.shrinkText = '展开'
        this.showRowNum = this.shrinkRowNum
      }
      console.debug(this.showRowNum)
    },
    eventCode2eventCodeWeb(num) {
      //后端code to 前端code
      let key = null
      switch (num) {
        case 1:
          key = 1
          break
        case 2:
          key = 0
          break
        case 3:
          key = 2
          break
        case 5:
          key = 4
          break
        case 6:
          key = 5
          break
        case 4:
          key = 6
          break
        case 9:
          key = 3
          break
        case 0:
          key = 7
          break
        default:
          key = null
          break
      }
      return key
    },
    eventCodeWeb2eventKey(num) {
      let key = ''
      switch (num) {
        case 0:
          key = 'point'
          break
        case 1:
          key = 'goal'
          break
        case 2:
          key = 'ownGoal'
          break
        case 3:
          key = 'offStage'
          break
        case 4:
          key = 'yellowCard'
          break
        case 5:
          key = 'redCard'
          break
        case 6:
          key = 'onStage'
          break
        default:
          key = null
          break
      }
      return key
    },
  },
}
</script>
<style lang="scss" scoped>
.lineup_subList {
  /* padding: 0 2.6% 1.388vw 2.6%; */
  width: 100%;
  .subLineup_title {
    width: 100%;
    height: 2.5vw;
    padding: 0 2.6%;
    font-size: 1.04vw;
    color: var(--mixtmt_greyColor3);
    font-weight: bold;
    line-height: 2.5vw;
  }
  .table_container {
    position: relative;
    transition: height 0.3s ease-in-out;
    height: 0;
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
    &::before {
      position: absolute;
      left: 50%;
      top: 0;
      z-index: 2;
      content: '\20';
      width: 1px;
      height: 100%;
      background-color: var(--mixtmt_greyColor7);
    }
    .tableUl {
      /* padding: 0 0.2rem; */
      width: 100%;
      height: auto;
      box-sizing: border-box;
      &.maxTeam {
        .itemRow {
          &:last-child {
            border-bottom: none;
          }
        }
      }
      .itemRow {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0 0.347vw;
        height: 4.16vw;
        transition: opacity 0.1s linear 0.2s;
        border-top: 1px solid var(--mixtmt_greyColor7);
        &:last-child {
          border-bottom: 1px solid var(--mixtmt_greyColor7);
        }
        .leftPlayerItem {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 65%;
          height: 4.16vw;
          color: var(--mixtmt_greyColor3);
          .playerLogo {
            position: relative;
            width: 3.47vw;
            height: 3.47vw;
            border-radius: 50%;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
            .defautlPlayerImg {
              display: block;
              width: 100%;
              height: 100%;
              background-size: 100% 100%;
              background-position: center;
              background-repeat: no-repeat;
              background-image: url('data:image/png;base64,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');
            }
            .shirtNumber {
              position: absolute;
              bottom: 0;
              right: 0;
              z-index: 2;
              width: 1.388vw;
              height: 1.388vw;
              margin-right: -0.694vw;
              padding-top: 0.111vw;
              border-radius: 50%;
              font-size: 0.974vw;
              line-height: 1.388vw;
              color: var(--mixtmt_whiteColor);
              text-align: center;
              font-weight: bold;
              font-family: 'DINCondensed-Bold';
              /* background-color: #d02856; */
            }
          }
          .inforRow {
            padding: 0 0.27vw 0 0.974vw;
            width: calc(100% - 4.58vw);
          }
        }
        .rightPlayerItem {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 35%;
          height: 4.16vw;
          color: var(--mixtmt_greyColor3);
          .inforRow {
            width: 100%;
          }
        }
        .inforRow {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          .inforRow_1 {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            color: var(--mixtmt_greyColor3);
            .playerName {
              width: 13vw;
              padding-right: 0.694vw;
              font-size: 0.974vw;
              line-height: 1.388vw;
              font-weight: bold;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .playerPos,
            .playerGrade {
              width: auto;
              padding: 0.138vw 0.416vw;
              background-color: var(--mixtmt_greyColor0);
              font-size: 0.833vw;
              line-height: 1.11vw;
            }
            .playerGrade {
              margin-left: 0.277vw;
            }
          }
          .inforRow_2 {
            padding-top: 0.347vw;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            color: var(--mixtmt_greyColor3);
            & > span {
              margin-left: 0.347vw;
              &:first-child {
                margin-left: 0;
              }
            }
            .onStage,
            .offStage {
              position: relative;
              font-size: 0.833vw;
              line-height: 1.388vw;
              padding-left: 1.388vw;
              &::before {
                content: '\20';
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
                width: 1.388vw;
                height: 1.388vw;
                background-position: center;
                background-size: 100% 100%;
                background-repeat: no-repeat;
              }
            }
            .onStage {
              &::before {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACdklEQVRoBe1WTWjUQBR+E3UR8eAPeNkktLvHInbtVRA9ePLi3av4hyioKCJSERGFFhSKFG967FEUREXF+25W6XE3bncLxVM9CW3zni9gD53dJpNJMqBMLuG9efO+731fMgmAvawCVoHSFHCb4fHSmv9t7JQF4La6NwnwMw9xryyMuK8oo7kXhBcQ8flmbyHg/qBRn96Mi7wXPoAbdM8SwUsg2trbEQ+WJ2uFu7EVJKc0bvDjDCEuANCOka2EeLjcqN0duaaZLGwAL+ieIqLXrH4liYsjnEf9xvidpJosa4UM4AedYxGKd6z8HhVwBn08OFq/rVKbVpP7FPK/9aYQ4Y0q+ZgQAdziU+pJGjmV9VwO+EFvIsLoC1M6qAI2VOOIGX6xbwzlMyS0HfC+L9URo/fa5GOSSNe9Vjibge9QqZYD1fbABVz7ykfl2FBHjQR/J57yd+KaxlbI7EC9vXKIyX8oinxMmk+uq26z+0xngEwO8Au7H6PoEx+XR3TA0vYIIeb6k+NX+M7vudql7MDE4s+9uBG9LYt8TJd7X+Yv+RzflYVVKhwLw90bq8jk4YSaLvmqWNX5pUbtoooTqQ5MEe1aX6UFU+Tj0RHgPP8Qzqs4kTjANJGz0gpfsben82mafTeTP+e1wxdpQyQ+QrXFjr++5pxUgSegGQY7oFIrQPzmx+OSSm1lZ+Vj53C1v11t4gDbbRqVrzY7Pc77o9bkHIP+4n+hfXJeJ058hHQamt5jBzCtuIxnHZAVMR1bB0wrLuNZB2RFTMfWAdOKy3jWAVkR07F1wLTiMp51QFbEdGwdMK24jGcdkBUxHf/zDpgWzOL9dwr8ARaTw1dCUaj9AAAAAElFTkSuQmCC');
              }
            }
            .offStage {
              &::before {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACiElEQVRoBe1ZPYgTQRSeNzF6HMbdRbCMv2BhYWEvKAcWJ4KVFt6PhcoJh4UcIqIcIiIixyF3HOLPmd1gqZ2FIKJY2FjaXXQ3CoIIJka84zB5zisW9tTdnezbYIqZZmbevPe+731vshsSIcwwCrAUAFZ0JPhb+QRGtqlLp17NBVumIvW5gyngfzfIdMB0gKmAuUJMAdnhpgNsCZkJTAeYArLDTQfYEjITmA4wBWSHmw6wJWQmMB1gCsgONx1gS8hMkPjTxvKO0fJKBw9qYXRwUcsvdJJwMlwmzRsK654P1hY/xvkkFoDT07L5oPYIBR6LS9BLOwDct3z3lJpjf3NKLIDI4b7TxcbX5ccC8XAvyf6ZW5G+q8ifSSJPMakFkBNuGx9oYvspIh6gfa+HInXHCryJNPLEQ+spBP7DFWtj6QiAeNNz8iAXdMkTF60OhKQb5QkH4ccLdZ32hrZcZ4B523cndZQPcbsqgIJaO0e2tH/hK0SxO0ySywxyzgncyW5zaV2haNJSzfuyvjgwpFTyo3bWWsLtLOQJs+sCKGhw6d4nUZRD6gJ+pj1nSAGzju+dy5qj6ysUBWrtGtvTXu28VO+JzVG77lqCmLGC6nld/3/5ZepAmKi0VHmnmnhIdeJ7aNOdAeQtLnnCYhVACex65W2hIIfVA+0n7XUGSLhpB+6Ujm+aD7sAAtj03n0NBXlUvSdW0wBBwA3b9y6k+eme51IAgdkfKs9QyOPqQ9WOA1cFXrfr3sW48yz23AogcPUofAJCjqsi/v7yBXDNDqqXspBMism1AAKy6m5VSDi7BlTCVSfwLq+x9fumsXV0iv56bZZHrvQ711h+re1j+2MPzYFRwCiQiwK/AW6dkE1GMlycAAAAAElFTkSuQmCC');
              }
            }
            .point,
            .goal,
            .ownGoal {
              width: 1.388vw;
              height: 1.388vw;
              background-position: center;
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
            .goal {
              background-image: url('data:image/png;base64,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');
            }
            .ownGoal {
              background-image: url('data:image/png;base64,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');
            }
            .point {
              background-image: url('data:image/png;base64,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');
            }
            .yellowCard,
            .redCard {
              position: relative;
              display: block;
              width: 1.388vw;
              height: 1.388vw;
              &::before {
                position: absolute;
                left: 0.219vw;
                top: 0;
                z-index: 2;
                content: '\20';
                width: 0.974vw;
                height: 100%;
              }
            }
            .yellowCard {
              &::before {
                background-color: #f4e336;
              }
            }
            .redCard {
              &::before {
                background-color: #c80505;
              }
            }
            .injured {
              width: auto;
              padding: 0 0.347vw;
              font-size: 0.833vw;
              line-height: 1.388vw;
              color: var(--mixtmt_whiteColor);
              background-color: #e24d23;
              border-radius: 0.278vw;
            }
          }
        }
      }
      &.home {
        .itemRow {
          .leftPlayerItem {
            .playerLogo {
              .shirtNumber {
                background-color: var(
                  --mixtmt_echarts_shootDis_ExpetGoal_homeColor
                );
              }
            }
          }
        }
      }
      &.away {
        .itemRow {
          .leftPlayerItem {
            .playerLogo {
              .shirtNumber {
                background-color: var(
                  --mixtmt_echarts_shootDis_ExpetGoal_awayColor
                );
              }
            }
          }
        }
      }
    }
  }

  .shrinkBox {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 10;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    height: 4.16vw;
    width: 100%;
    color: var(--mixtmt_greyColor3);
    background-color: var(--mixtmt_greyColor12);
    &.borderRadius {
      border-radius: 0 0 1.042vw 1.042vw;
    }
    .shrinkText {
      padding-right: 0.2778vw;
      font-size: 1.11vw;
      font-weight: bold;
    }
    .arrowIcon.unquoteClass {
      width: 0;
      height: 0;
      border-right: 0.2778vw solid transparent;
      border-left: 0.2778vw solid transparent;
      border-bottom: 0.416vw solid var(--mixtmt_greyColor3);
      transform: rotate(0);
      transform-origin: 50% 50%;
      transition: transform 0.3s linear;
      &.show {
        transform: rotate(180deg);
      }
    }
  }
}

.mixtmt_pc {
  .lineup_subList {
    .home {
      .leftPlayerItem {
        .playerLogo {
          &:hover {
            & ~ .inforRow {
              .inforRow_1 {
                .playerName {
                  color: var(--mixtmt_echarts_shootDis_ExpetGoal_homeColor);
                }
              }
            }
          }
        }
        .inforRow_1 {
          .playerName {
            &:hover {
              color: var(--mixtmt_echarts_shootDis_ExpetGoal_homeColor);
            }
          }
        }
      }
    }
    .away {
      .leftPlayerItem {
        .playerLogo {
          &:hover {
            & ~ .inforRow {
              .inforRow_1 {
                .playerName {
                  color: var(--mixtmt_echarts_shootDis_ExpetGoal_awayColor);
                }
              }
            }
          }
        }
        .inforRow_1 {
          .playerName {
            &:hover {
              color: var(--mixtmt_echarts_shootDis_ExpetGoal_awayColor);
            }
          }
        }
      }
    }
    .leftPlayerItem {
      .playerLogo {
        &:hover {
          cursor: pointer;
          & ~ .inforRow {
            .inforRow_1 {
              .playerName {
                text-decoration: underline;
              }
            }
          }
        }
      }
      .inforRow_1 {
        .playerName {
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }
    &.onlyDisplay {
      .leftPlayerItem {
        .playerLogo {
          &:hover {
            cursor: default;
            & ~ .inforRow {
              .inforRow_1 {
                .playerName {
                  text-decoration: none;
                  color: var(--mixtmt_greyColor3);
                }
              }
            }
          }
        }
        .inforRow_1 {
          .playerName {
            &:hover {
              cursor: default;
              text-decoration: none;
              color: var(--mixtmt_greyColor3);
            }
          }
        }
      }
    }
  }
  .shrinkBox {
    &:hover {
      cursor: pointer;
      background-color: var(--mixtmt_mainColor0);
      color: var(--mixtmt_whiteColor);
      .arrowIcon.unquoteClass {
        border-bottom: 0.416vw solid var(--mixtmt_whiteColor);
      }
    }
  }
}
</style>
